<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 0;
        left: 0;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1170 275">
    <g id="Layer_2" data-name="Layer 2">
        <g id="topbar">
            <rect {fill} id="topbar-2" data-name="topbar" width="1170" height="275" />
        </g>
    </g>
</svg>
